"use client";

import type React from "react";

export interface FooterStoryProps {
  sectionTitle: string;
  title: string;
  description: string;
}

const FooterStory: React.FC<FooterStoryProps> = ({
  sectionTitle,
  title,
  description,
}) => {
  return (
    <div className="mb-16">
      <div className="mb-12">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-12 h-px bg-black/30"></div>
          <h2 className="text-xs uppercase tracking-[0.2em] text-black/60 font-medium">
            {sectionTitle}
          </h2>
          <div className="flex-1 h-px bg-black/30"></div>
        </div>
        <h3 className="text-4xl font-bold text-black mb-6">{title}</h3>
        <p className="text-lg text-black/70 leading-relaxed mb-8">
          {description}
        </p>
      </div>
    </div>
  );
};

export default FooterStory;
